import React from 'react';

import AdvertList from '@Components/Advert/AdvertList';
import SearchItemsContentLoader from '@Components/Loaders/SearchItemsContentLoader';
import PageSection from '@Components/sections/PageSection';
import { Messages } from '@Config/messages';
import { useGetCompanyAdsByIdQuery } from '@Graphql/graphqlTypes.generated';
import useAdvertHistory from '@Utils/hooks/useAdvertHistory';

import styles from './LastPreviewedAdverts.module.scss';

interface LastPreviewedAdvertsProps {
  itemsCount: number;
  advertId: string;
}

const LastPreviewedAdverts: React.FunctionComponent<LastPreviewedAdvertsProps> = ({ itemsCount, advertId }) => {
  const { advertHistory } = useAdvertHistory();

  const lastPreviewedAdverts = advertHistory.filter(id => id !== advertId);

  const { data, loading } = useGetCompanyAdsByIdQuery({
    variables: { advertIds: lastPreviewedAdverts, limit: itemsCount },
    skip: !lastPreviewedAdverts.length,
    fetchPolicy: 'network-only',
  });

  const advertsEdges = data?.allAdverts.edges || [];

  if (!advertsEdges.length) {
    return null;
  }

  return (
    <PageSection title={Messages.lastPreviewedAdvertsSectionTitle}>
      <div className={styles.lastPreviewedItemContainer}>
        {loading ? (
          <SearchItemsContentLoader count={itemsCount} gridSize={itemsCount} />
        ) : (
          <AdvertList adverts={advertsEdges.map(item => item.node)} />
        )}
      </div>
    </PageSection>
  );
};

export default LastPreviewedAdverts;
